import RemovableGooglePlace from "components/Removables/RemovableGooglePlace";
import React from "react";
import { GooglePlaceInput, GooglePlaceInputValue } from "./GooglePlaceInput";

interface Props {
  value: GooglePlaceInputValue;
  onPlaceSelected: (place: GooglePlaceInputValue) => void;
  focusOnMount?: boolean;
}

export const GooglePlaceInputWithValue = (props: Props) => {
  return <div className="flex-column gap-small">
    {props.value && <RemovableGooglePlace
      value={props.value}
      onChange={() => props.onPlaceSelected(null)}
      readonly={false}
      error={false}
    />}
    {!props.value && <GooglePlaceInput
      onPlaceSelected={props.onPlaceSelected}
      focusOnMount={props.focusOnMount}
    />}
  </div>
}